import { render, staticRenderFns } from "./traceIndex.vue?vue&type=template&id=06dbd7a7&scoped=true&"
import script from "./traceIndex.vue?vue&type=script&lang=js&"
export * from "./traceIndex.vue?vue&type=script&lang=js&"
import style0 from "./traceIndex.vue?vue&type=style&index=0&id=06dbd7a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dbd7a7",
  null
  
)

export default component.exports